import Logger from 'services/Logger'

export interface Assertion {
	fn: <T>(value: T) => boolean
	name?: string
}

const checkAssertions = <T>(value: T, assertions: Assertion[]): Array<string> => {
	return assertions
		.map((assertion, index) => (assertion.fn(value) ? '_PASSED' : assertion.name || `Assertion ${index}`))
		.filter(x => x != '_PASSED')
}

const logAssertions = (failedAssertions: string[]) => {
	Logger.warn(`Assertions Failed: ${failedAssertions.join(', ')}`)
}

const throwAssertions = (failedAssertions: string[]) => {
	throw new AssertionError(`Assertions Failed: ${failedAssertions.join(', ')}`)
}

/**
 * Checks each assertion and returns an object of booleans representing their status
 * @param {T} value
 * @param {Assertion[]} assertions
 * @returns {Record<string, boolean>}
 */
export const Assert = {
	log: <T>(value: T, assertions: Assertion[]) => logAssertions(checkAssertions(value, assertions)),
	throws: <T>(value: T, assertions: Assertion[]) => throwAssertions(checkAssertions(value, assertions))
}

class AssertionError extends Error {
	name = 'AssertionError'
	constructor(msg?: string) {
		super(msg)
	}
}
